import React from 'react';

export default function CommunityGuidelines({ onBack }) {
    return React.createElement('div', {
        className: 'glass-panel animate-fade-in',
        style: { maxWidth: '800px', margin: '0 auto', padding: '40px' }
    },
        React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' } },
            React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: '20px' } },
                // Mascot
                React.createElement('img', {
                    src: "/images/mascots/SparkBan.png",
                    alt: "SparkBan Mascot",
                    style: { height: '80px', width: 'auto', objectFit: 'contain' },
                    onError: (e) => e.target.style.display = 'none'
                }),
                React.createElement('h1', {
                    style: {
                        fontSize: '32px',
                        background: 'linear-gradient(135deg, var(--primary), var(--secondary))',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        margin: 0
                    }
                }, "Community Guidelines")
            ),
            onBack && React.createElement('button', {
                onClick: onBack,
                className: 'btn-ghost',
                style: { color: 'var(--text-muted)' }
            }, "Back")
        ),

        React.createElement('p', { style: { fontSize: '18px', marginBottom: '30px', lineHeight: '1.6' } },
            "Welcome to Spark Inspo! To keep this community safe, creative, and fun for everyone, we ask that you follow these simple rules. Failure to do so may result in your account being banned."
        ),

        React.createElement('div', { style: { display: 'grid', gap: '20px' } },

            // Rule 1
            React.createElement('div', { style: { background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #8b5cf6' } },
                React.createElement('h3', { style: { marginBottom: '10px', fontSize: '20px' } }, "1. Age Requirement 🎂"),
                React.createElement('p', { style: { color: 'var(--text-muted)' } }, "You must be at least 13 years old to use this platform. If you are under 18, we recommend having parental guidance.")
            ),

            // Rule 2
            React.createElement('div', { style: { background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #ec4899' } },
                React.createElement('h3', { style: { marginBottom: '10px', fontSize: '20px' } }, "2. Be Kind & Respectful 💜"),
                React.createElement('p', { style: { color: 'var(--text-muted)' } }, "We have a zero-tolerance policy for bullying, harassment, hate speech, or discrimination of any kind. Treat others the way you want to be treated.")
            ),

            // Rule 3
            React.createElement('div', { style: { background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #ef4444' } },
                React.createElement('h3', { style: { marginBottom: '10px', fontSize: '20px' } }, "3. Safe Content Only 🛡️"),
                React.createElement('p', { style: { color: 'var(--text-muted)' } }, "Do not post nudity, sexual content, severe violence, or anything illegal. This is a place for creativity, not shock value.")
            ),

            // Rule 4
            React.createElement('div', { style: { background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #f59e0b' } },
                React.createElement('h3', { style: { marginBottom: '10px', fontSize: '20px' } }, "4. Respect Privacy 🔒"),
                React.createElement('p', { style: { color: 'var(--text-muted)' } }, "Do not share personal information (addresses, phone numbers, passwords) of yourself or others.")
            ),

            // Rule 5
            React.createElement('div', { style: { background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #10b981' } },
                React.createElement('h3', { style: { marginBottom: '10px', fontSize: '20px' } }, "5. Be Authentic ✨"),
                React.createElement('p', { style: { color: 'var(--text-muted)' } }, "No spamming, scams, or impersonating others. Be yourself and share your own unique sparks!")
            )
        ),

        React.createElement('div', { style: { marginTop: '40px', padding: '20px', background: 'rgba(139, 92, 246, 0.1)', borderRadius: '12px', textAlign: 'center' } },
            React.createElement('p', { style: { marginBottom: '0', fontWeight: 'bold' } }, "By using Spark Inspo, you agree to these guidelines.")
        )
    );
}
